export const IconCopyLink = () => {
  return (
    <svg
      width="40px"
      height="30px"
      viewBox="0 0 1024 1024"
      className="icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill=""
      stroke="">
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

      <g id="SVGRepo_iconCarrier">
        <path
          d="M823.1 200.7c-71.3-71.3-187.3-71.3-258.6 0L409.4 355.8c-71.3 71.3-71.3 187.3 0 258.6L446 651l51.7-51.7-36.6-36.6c-42.8-42.8-42.8-112.4 0-155.2l155.2-155.2c42.8-42.8 112.4-42.8 155.2 0 42.8 42.8 42.8 112.4 0 155.2l-71.3 71.3 51.7 51.7 71.3-71.3c71.2-71.2 71.2-187.2-0.1-258.5z"
          fill="#fff"
          strokeWidth="30"
        />

        <path
          d="M577.8 372.9L526 424.6l36.6 36.6c42.8 42.8 42.8 112.4 0 155.2L407.4 771.5c-42.8 42.8-112.4 42.8-155.2 0-42.8-42.8-42.8-112.4 0-155.2l58.4-58.4-51.6-51.7-58.4 58.4c-71.3 71.3-71.3 187.3 0 258.6 35.6 35.6 82.5 53.5 129.3 53.5 46.8 0 93.7-17.8 129.3-53.5L614.4 668c71.3-71.3 71.3-187.3 0-258.6l-36.6-36.5z"
          fill="#fff"
          strokeWidth="30"
        />
      </g>
    </svg>
  );
};
